import { Route, AppId, createPageRoute } from '@lumapps/router';

export const signInPageRoute: Route = createPageRoute({
    slug: 'platform/sign-in-page',
    id: 'sign-in-page',
    appId: AppId.backOffice,
});
